import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { textAlign, verticalAlign } from 'styled-system';

import sx from '../../internal/styles/sx';
import { TableCellProps } from './types';

const TableCell = styled('td', { shouldForwardProp })<TableCellProps>(
  textAlign,
  verticalAlign,
  sx
);

export default TableCell;
